import { arrayOf, bool, number, shape, string } from "prop-types";
import { SectionShape } from "./section.shape";

export const SectionGroupShape = shape({
  title: string,
  sections: arrayOf(SectionShape),
  position: number,
  showTitle: bool
});

export default SectionGroupShape;
